
import { AuthService } from "@/services/auth-service";
import { SaleService } from "@/services/sale-service";
import AppSaleTypeSelect from "./SaleTypeSelect.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			saleTypeId: SaleService.getTypes()[0].ID,
			beginDate: new Date(),
			endDate: new Date(),
			invoiceDate: new Date(),
			creating: false
		};
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (this.creating) return;
			this.creating = true;
			try{
				localStorage.setItem(`default-sale-type-for-dagontvangst-${AuthService.wfDossier.id}`, `${this.saleTypeId}`);
				let newDocCount = await SaleService.createDagontvangst(this.saleTypeId, this.beginDate, this.endDate, this.invoiceDate);
				this.$wf.notify(this.$ctc("new-documents-created", newDocCount, {count: newDocCount}), "success", 3000, "check");
				this.$emit("refresh");
				this.$emit("close");
			}catch(err){

			}
			this.creating = false;
		}
	},
	async created(){
		this.saleTypeId = parseInt(localStorage.getItem(`default-sale-type-for-dagontvangst-${AuthService.wfDossier.id}`) || "9");
		if (this.saleTypeId < 3) {
			this.saleTypeId = 9;
		}
	},
	components: {
		AppSaleTypeSelect
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
